import { supabase } from '../config/supabase';
import type { Trip } from '../types/database';

export interface FleetOperatorRecommendation {
  fleet_operator_id: string;
  operator_name: string;
  vehicle_id: string;
  fleet_number: string;
  model: string;
  capacity: number;
  driver_id: string;
  driver_name: string;
  score: number;
  distance_meters: number | null;
  breakdown: {
    distance_score: number;
    capacity_fit_score: number;
  };
}

export async function recommendFleetOperatorsForTrip(
  tripId: string,
  limit = 5,
  requireAcceptingTasks = false
): Promise<FleetOperatorRecommendation[]> {
  const { data, error } = await supabase.rpc('recommend_fleet_operators_for_trip', {
    p_trip_id: tripId,
    p_limit: limit,
    p_require_accepting_tasks: requireAcceptingTasks,
  });

  if (error) throw new Error(error.message);
  return (data ?? []) as FleetOperatorRecommendation[];
}

export async function assignPlatformTripToOwner(params: {
  tripId: string;
  fleetOperatorId: string;
  vehicleId: string;
  driverId: string;
}): Promise<Trip> {
  const { data, error } = await supabase.rpc('assign_platform_trip_to_owner', {
    p_trip_id: params.tripId,
    p_fleet_operator_id: params.fleetOperatorId,
    p_vehicle_id: params.vehicleId,
    p_driver_id: params.driverId,
  });

  if (error) throw new Error(error.message);
  return data as Trip;
}

export async function acceptPlatformTrip(tripId: string): Promise<Trip> {
  const { data, error } = await supabase.rpc('accept_platform_trip', {
    p_trip_id: tripId,
  });

  if (error) throw new Error(error.message);
  return data as Trip;
}

export async function rejectPlatformTrip(
  tripId: string,
  reason?: string
): Promise<Trip> {
  const { data, error } = await supabase.rpc('reject_platform_trip', {
    p_trip_id: tripId,
    p_reason: reason ?? null,
  });

  if (error) throw new Error(error.message);
  return data as Trip;
}

export function formatFleetOperatorRecommendation(rec: FleetOperatorRecommendation): string {
  const dist =
    rec.distance_meters != null
      ? `${(rec.distance_meters / 1000).toFixed(1)} km`
      : '—';
  return `${rec.operator_name} · ${rec.fleet_number} (${rec.driver_name}) · ${dist} · score ${Math.round(rec.score)}`;
}
